/* import __COLOCATED_TEMPLATE__ from './jp-smirf-enrollment-modal.hbs.js'; */
import Component from '@glimmer/component';
import { SetDashboardModalShownRequest } from '@square/dashboard-protos/models/squareup/jpsmirf/externalservice';
import JpSmirfService from '@dashboard/shared-ui/clients/jpsmirf';
export default class JpSmirfEnrollmentModal extends Component {
  constructor(owner, args) {
    super(owner, args);
    JpSmirfService.setDashboardModalShown(SetDashboardModalShownRequest.create({}));
  }
  get checkEligibilityLink() {
    return '/dashboard/account/jp-smirf-enrollment';
  }
}